<template>
  <span>
    <WdsTooltip global>
      <template #tooltip-content>
        <span v-if="!column.publishedAt">
          {{ $t('Not published') }}
        </span>
        <span v-else>
          {{ $t('Published: :publishedDate', { publishedDate }) }}
          <span v-if="column.isForContacts || column.isForContacts || column.isForRecruiters">
            <br />
            {{ $t('Channels:') }}
            <span v-if="column.isForMarketplace">
              <br />
              {{ $t('Marketplace') }}
            </span>
            <span v-if="column.isForContacts">
              <br />
              {{ $t('Trusted contacts') }}
            </span>
            <span v-if="column.isForRecruiters">
              <br />
              {{ $t('Staffing agencies') }}
            </span>
          </span>
        </span>
      </template>
      <WdsIcon name="share" :size="16" :color="column.publishedAt ? '#1F6021' : '#B2B2BF'" />
    </WdsTooltip>
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { WdsIcon, WdsTooltip } from '@worksome/wds-components'
import { FragmentType, graphql, useFragment } from '@/gql'
import { $t } from '@/app-bootstrapping/SetUpInternationalization'
import useDate from '@/composables/useDate'

const JobSharedChannelsColumn = graphql(`
  fragment JobSharedChannelsColumn on Job {
    id
    publishedAt
    isForContacts
    isForRecruiters
    isForMarketplace
  }
`)

const props = defineProps<{
  row: FragmentType<typeof JobSharedChannelsColumn>
}>()
const column = computed(() => useFragment(JobSharedChannelsColumn, props.row))

const { date: publishedDate } = useDate(column.value.publishedAt)
</script>

<style lang="scss"></style>
